/* import __COLOCATED_TEMPLATE__ from './manage-actions-cta.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import { tracked } from '@glimmer/tracking';

import Component from '@glimmer/component';
import type AiAutomationAction from 'embercom/models/workflow-connector/ai-automation-action';
import { inject as service } from '@ember/service';
import type ArrayProxy from '@ember/array/proxy';

interface Signature {
  Args: {};
}

export default class ManageActionsCta extends Component<Signature> {
  @tracked actions: AiAutomationAction[] = [];
  @service declare store: $TSFixMe;

  constructor(owner: any, args: any) {
    super(owner, args);
    this.fetchActions();
  }

  async fetchActions() {
    let actions: ArrayProxy<AiAutomationAction> = await this.store.findAll(
      'workflow-connector/ai-automation-action',
    );

    if (!actions) {
      return;
    }
    this.actions = actions
      .filterBy('isTemplate', false)
      .filter((act) => act.finEnabled || act.usage === 'fin')
      .slice(0, 3);
  }

  get customActionsRoute() {
    return 'apps.app.settings.app-settings.custom-actions.custom-action';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAutomation::ManageActionsCta': typeof ManageActionsCta;
    'ai-automation/manage-actions-cta': typeof ManageActionsCta;
  }
}
